/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled from "styled-components";
import Stack from "../ui/Stack";
import Flex from "../ui/Flex";
import Text from "../ui/Text";
import FormatPrice from "../formatters/FormatPrice";

const StyledWaitingListDueNow = styled(Stack)`
  padding-top: 1.5rem;
  padding-inline: 1.5rem;
  margin-top: 0.5rem;
  border-top: 1px solid rgba(${({ theme }) => theme.colors.border.rgba});
`;

const WaitingListDueNow = ({ currency }) => {
  return (
    <StyledWaitingListDueNow $gap="0.5rem">
      <Flex $align="center" $justify="space-between">
        <Text color="dark" weight="bold">Due now to join</Text>
        <Text color="accent" weight="bold">
          <FormatPrice value={0} currency={currency} />
        </Text>
      </Flex>
      <Text size="small" color="dark">Joining the list is free, therefore no payment is required now</Text>
    </StyledWaitingListDueNow>
  );
};

export default WaitingListDueNow;
